import { useEffect, useState } from "react";
import { Truck } from "lucide-react";
import { http, euro } from "../lib/api";
import { useCart } from "../lib/store";

export function FreeShippingHint({ productId, lineCents, compact = false }) {
  const { items } = useCart();
  const [goal, setGoal] = useState(null);
  const [others, setOthers] = useState(0);
  useEffect(() => { http.get("/site").then((r) => setGoal(r.data.shipping?.free_above_cents || r.data.shipping?.rates?.find((x) => x.free_above_cents)?.free_above_cents || null)); }, []);
  useEffect(() => {
    const rest = items.filter((i) => i.product_id !== productId && !i.sample);
    if (!rest.length) { setOthers(0); return; }
    http.post("/cart/quote", { items: rest.map(({ product_id, packs }) => ({ product_id, packs })), delivery_method: "delivery" }).then((r) => setOthers(r.data.subtotal_cents || 0));
  }, [items, productId]);
  if (!goal || !lineCents) return null;
  const total = others + lineCents;
  const left = Math.max(goal - total, 0);
  const pct = Math.min(100, Math.round((total / goal) * 100));
  const text = left === 0
    ? <>De gratisbezorggrens is bereikt; je bezorgadres wordt gecontroleerd bij het afrekenen</>
    : <>Nog <strong>{euro(left)}</strong> tot gratis bezorging{others ? " (incl. je winkelwagen)" : ""}</>;
  if (compact) return <p className="text-[11px] text-[#4A5056] flex items-center gap-1.5" data-testid="mobile-free-shipping-hint"><Truck size={12} className={left === 0 ? "text-[#2E7D32]" : "text-[#B78B7B]"} />{text}</p>;
  return (
    <div className="space-y-2" data-testid="product-free-shipping-hint">
      <p className="text-sm flex items-center gap-2" data-testid="product-free-shipping-text"><Truck size={15} className={left === 0 ? "text-[#2E7D32]" : "text-[#B78B7B]"} />{text}</p>
      <div className="h-1 rounded-full bg-[#EFE9E2] overflow-hidden"><div className={`h-full rounded-full transition-[width] duration-500 ease-out ${left === 0 ? "bg-[#2E7D32]" : "bg-[#B78B7B]"}`} style={{ width: `${pct}%` }} /></div>
    </div>);
}
